import { getProfile } from "@services/krent.service";
import { addCookie } from "@utils/cookies";

export interface GoogleAuthResult {
  success: boolean;
  token?: string;
  role?: string;
}

export async function persistGoogleSession(authRes: GoogleAuthResult): Promise<any> {
  if (!authRes.token) {
    throw new Error("Authentication failed. No session token received.");
  }

  addCookie("1Q_SPA", authRes.token, 24000);

  return getProfile(new AbortController().signal)
    .then((profileRes: any) => {
      if (profileRes?.data) {
        sessionStorage.setItem("user", JSON.stringify(profileRes.data));
        return profileRes.data;
      }
    })
    .catch(() => {});
}

export function getRouteForGoogleRole(
  role?: string,
  redirectUrl?: string,
): string {
  if (redirectUrl) return redirectUrl;

  switch (role) {
    case "agent":
      return "/purchases";
    case "developer":
      return "/developer-dashboard";
    case "landlord":
    case "property-manager":
      return "/overview";
    default:
      return "/explore-listings";
  }
}
